/* eslint-disable react/jsx-props-no-spreading */
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from 'redux/api_slice';
import GiftCards from './gift_cards';

// Since Brilliant Travels doesn't have the ecom object defined,
// we need to create a new store here to use the RTK Queries
const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export default (props) => (
  <Provider store={store}>
    <GiftCards {...props} />
  </Provider>
);
